import {Box} from '@mantine/core';
import {BasicButton} from '@packages/ui';
import Image from 'next/image';
import type {FC} from 'react';
import {
  MdChat,
  MdEmail,
  MdInsertDriveFile,
  MdOutlineCorporateFare,
} from 'react-icons/md';
import {COLOR_BLACK_1} from '../../../../config/constants/colorCodes';
import {REMIND_PASS} from '../../../../config/constants/routes';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {getMailAuthLinkWithParamsHooks} from '../../../../shared/services/getMailAuthLinkWithParamsHooks';
import {LoginForm, type LoginFormContainerProps} from './LoginForm';

const PATH_BANNER_IMAGE = '/next-image/login/app_dl_banner_pc_2.jpg';

type Props = LoginFormContainerProps;

export const LoginPageForPc: FC<Props> = ({
  useFormLogin,
  submitLogin,
  isLoading,
  hasError,
}) => {
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <Box className="w-full max-w-[1200px]">
      <Box className="mb-16 bg-white px-8 py-16 text-base pc:p-32">
        <div className="mb-20">
          <p className="text-black-1 text-xl">外資就活ドットコムとは</p>
          <p className="text-black-1 text-base">
            外資就活ドットコムは、プロフェッショナルを目指す学生のための就職活動支援メディアです。
          </p>
        </div>
        <div className="flex justify-between">
          <div className="w-1/2">
            <div className="mb-16">
              <p className="text-black-1 text-center text-md">
                会員限定サービス
              </p>
            </div>
            <div className="mb-24 flex flex-wrap justify-between">
              <div className="w-1/2">
                <div className="flex justify-center">
                  <MdOutlineCorporateFare fill={COLOR_BLACK_1} size={87} />
                </div>
                <p className="text-black-1 text-md font-bold text-center">
                  厳選企業の募集情報
                </p>
                <p className="text-black-1 text-base text-center">
                  外資系・日系トップ企業の最新
                  <br />
                  インターン・本選考情報が届く
                </p>
              </div>
              <div className="w-1/2">
                <div className="flex justify-center">
                  <MdInsertDriveFile fill={COLOR_BLACK_1} size={87} />
                </div>
                <p className="text-black-1 text-md font-bold text-center">
                  先輩のES・体験記
                </p>
                <p className="text-black-1 text-base text-center">
                  実際のインターンや本選考に
                  <br />
                  関する体験レポートが読める
                </p>
              </div>
              <div className="w-1/2">
                <div className="flex justify-center">
                  <MdChat fill={COLOR_BLACK_1} size={87} />
                </div>
                <p className="text-black-1 text-md font-bold text-center">
                  内定者に聞くコミュニティ
                </p>
                <p className="text-black-1 text-base text-center">
                  トップ企業内定者や社会人OBに
                  <br />
                  就活の疑問・悩みを聞ける
                </p>
              </div>
              <div className="w-1/2">
                <div className="flex justify-center">
                  <MdEmail fill={COLOR_BLACK_1} size={87} />
                </div>
                <p className="text-black-1 text-md font-bold text-center">
                  Premiumスカウト
                </p>
                <p className="text-black-1 text-base text-center">
                  厳選した優良企業から、
                  <br />
                  会食や面接などのスカウトが届く
                </p>
              </div>
            </div>
            <BasicButton
              isPrimary={true}
              isLarge={true}
              onClick={() => {
                location.href = mailAuthLink;
              }}
            >
              新規会員登録
            </BasicButton>
          </div>
          <div className="w-1/2 flex justify-center items-center">
            <div className="w-[410px] flex flex-col items-center justify-center">
              <div className="mb-12 w-full">
                <LoginForm
                  useFormLogin={useFormLogin}
                  submitLogin={submitLogin}
                  isLoading={isLoading}
                  hasError={hasError}
                />
              </div>
              <div className="mb-20 flex justify-start">
                <CommonLink
                  href={REMIND_PASS}
                  className="text-base text-link underline text-left"
                >
                  パスワードを忘れた方はこちら
                </CommonLink>
              </div>
              <Image
                src={PATH_BANNER_IMAGE}
                width={820}
                height={340}
                alt="選考前はアプリで選考体験記を見直そう！外資就活アプリ"
              />
            </div>
          </div>
        </div>
      </Box>
    </Box>
  );
};
